import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LetDirective, PushPipe } from '@ngrx/component';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { IconComponent } from './components/icon/icon.component';
import { ModalConfirmComponent } from './components/modal-confirm/modal-confirm.component';
import { ModalContainerComponent } from './components/modal-container/modal-container.component';
import { ModalInfoComponent } from './components/modal-info/modal-info.component';
import { ModalSuccessComponent } from './components/modal-success/modal-success.component';
import { AutoFocusDirective } from './directives/auto-focus.directive';

// exports of this module are shared between "core" and "shared"
// ModalConfirmComponent is used in core's dialog.service and several shared/components
@NgModule({
    imports: [CommonModule, TranslateModule, InlineSVGModule, FormsModule, LetDirective, PushPipe],
    declarations: [ModalConfirmComponent, ModalSuccessComponent, ModalInfoComponent, ModalContainerComponent, IconComponent, AutoFocusDirective],
    exports: [
        ModalConfirmComponent,
        ModalSuccessComponent,
        ModalInfoComponent,
        ModalContainerComponent,
        IconComponent,
        AutoFocusDirective,
        LetDirective,
        PushPipe,
    ],
})
export class CoreSharedModule {}
